import React, { ReactNode } from 'react';
import { VideoModal } from '../../layouts/VideoModal';
import { container } from '../../styles/themes';
import { classNames } from '../../utils/style';
import { fontHeading1 } from '../../styles/typographyNew';
import { Rating } from '../../components/Rating';
import { ImageProps } from '../../components/Image/types';

export interface HeroVideoProps {
  className?: string;
  ctaButtons?: ReactNode[];
  ctaDisclaimer?: string;
  title: string;
  description?: ReactNode;
  ratings: number;
  ratingsDisclaimer?: string;
  videoImage?: ImageProps;
  VideoPlayer?: ReactNode;
  onClickVideoThumbnail?: ReactNode;
  ShortVideo?: ReactNode;
  activeModal?: boolean;
}

export const HeroVideo = ({
  title,
  description,
  ratings,
  ratingsDisclaimer,
  ctaButtons,
  ctaDisclaimer,
  videoImage,
  VideoPlayer,
  onClickVideoThumbnail,
  ShortVideo,
  activeModal = true,
}: HeroVideoProps) => {
  return (
    <>
      <section
        id="hero-video"
        className={classNames(
          container,
          'hero-video',
          'overflow-hidden pt-0 lg:pt-[12px]',
          'xl:max-w-[1240px]',
        )}
      >
        <div
          className={classNames(
            'flex flex-col lg:flex-row justify-between',
            'px-20 pt-40 lg:p-80 rounded-[40px]',
            'bg-heroVideo',
          )}
        >
          <div className="flex flex-col justify-center mb-24 lg:mb-0">
            <h1
              className={classNames(
                'mb-16 lg:mb-32 text-neutral-301 max-w-610',
                fontHeading1,
              )}
            >
              {title}
            </h1>
            {description && <div className="max-w-610">{description}</div>}
            <div
              className={classNames(
                'flex flex-row gap-12 justify-center lg:justify-start',
              )}
            >
              {ratings && <Rating className="mt-24" rating={ratings}></Rating>}
              {ratingsDisclaimer && (
                <p
                  className={classNames(
                    'text-[#768699] text-14 italic font-normal my-auto opacity-90 mt-24',
                  )}
                >
                  {ratingsDisclaimer}
                </p>
              )}
            </div>
            <div
              className={classNames(
                'flex flex-col lg:flex-row gap-12 mt-32 lg:mt-24 items-center',
              )}
            >
              {ctaButtons && ctaButtons.length > 0 && (
                <div
                  className={classNames(
                    'flex flex-col gap-12 lg:flex-row w-full lg:w-auto',
                  )}
                >
                  {ctaButtons}
                </div>
              )}
              {ctaDisclaimer && (
                <p
                  className={classNames(
                    'text-[#768699] text-14 italic font-normal my-auto opacity-90',
                  )}
                >
                  {ctaDisclaimer}
                </p>
              )}
            </div>
          </div>
          <div
            className={classNames(
              'relative flex w-full mb-32 lg:px-0 lg:mb-auto lg:mx-0',
              'lg:max-w-[380px]',
              'lg:items-center',
            )}
          >
            {activeModal ? (
              <VideoModal
                gradient={false}
                image={videoImage}
                VideoPlayer={VideoPlayer}
                onClick={onClickVideoThumbnail}
                ShortVideo={ShortVideo}
                className="w-full"
              />
            ) : (
              VideoPlayer
            )}
          </div>
        </div>
      </section>
    </>
  );
};
